"use client";

import React, { useEffect } from "react";
import Input from "../ui/input";
import PrimaryButton from "../ui/primary-button";
import { create, NewsletterErrors } from "./newsletter-form-actions";
import { useActionState } from "react";
import { toast } from "sonner";

const initialState: {
  status: string;
  errors?: NewsletterErrors;
  message?: string;
} = { status: "" };

const SubmitButton = ({ isPending }: { isPending: boolean }) => {
  return (
    <PrimaryButton
      type="submit"
      size="md"
      color="teal"
      aria-label="submit newsletter form input"
      disabled={isPending}
    >
      Subscribe to Our Newsletter
    </PrimaryButton>
  );
};

const NewsletterForm = () => {
  const [state, formAction, isPending] = useActionState(create, initialState);

  useEffect(() => {
    if (state?.message) {
      toast.error(state?.message);
    }
  }, [state]);

  return (
    <div className="flex h-fit min-h-[320px] w-[358px] flex-col justify-start rounded-3xl border border-neutral-200 bg-secondary-100 px-6 py-4 shadow-[4px_8px_24px_2px_rgba(0,65,66,0.1)] sm:w-[400px]">
      {state.status === "success" ? (
        <div className="flex flex-col gap-4">
          <h1 className="font-montserrat text-subheading-2 text-neutral-500">
            Thank you for joining the 34,000+ Care Indeed Community!
          </h1>
          <p className="font-roboto text-body-1-300 text-neutral-500">
            You&apos;ll get the latest home care news, tips, and resources
            straight to your inbox.
          </p>
          <p className="font-roboto text-body-1-300 text-neutral-500">
            Your privacy is important to us. If you decide our updates are not
            for you, you can unsubscribe at any time.
          </p>
        </div>
      ) : (
        <form
          id="newsletter-description-form"
          className="flex flex-col items-stretch gap-4"
          aria-label="newsletter form"
          action={formAction}
        >
          <h2 className="font-montserrat text-subheading-3-500 text-neutral-500">
            Learn more by joining the 34,000+ Care Indeed Community!
          </h2>
          <Input
            id="firstName"
            name="firstName"
            placeholder="First Name"
            autoComplete="given-name"
            aria-label="first name"
            required
            error={state.errors?.firstName && state.errors.firstName.length > 0}
            errorMessage={
              state.errors?.firstName && state.errors.firstName.length > 0
                ? state.errors.firstName.join(", ")
                : "First name is required"
            }
          />
          <Input
            id="lastName"
            name="lastName"
            placeholder="Last Name"
            autoComplete="family-name"
            aria-label="last name"
            required
            error={state.errors?.lastName && state.errors.lastName.length > 0}
            errorMessage={
              state.errors?.lastName && state.errors.lastName.length > 0
                ? state.errors.lastName.join(", ")
                : "Last name is required"
            }
          />
          <Input
            id="email"
            name="email"
            placeholder="Email Address"
            aria-label="email"
            type="email"
            autoComplete="email"
            required
            error={state.errors?.email && state.errors.email.length > 0}
            errorMessage={
              state.errors?.email && state.errors.email.length > 0
                ? state.errors.email.join(", ")
                : "Email is required"
            }
          />
          <SubmitButton isPending={isPending} />
        </form>
      )}
    </div>
  );
};

export default NewsletterForm;
